import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3;

import styled, { css } from 'styled-components';
import breakpoint, { breakpointValues } from 'pricing-pages-ui/constants/Breakpoints';
import { GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
export const borderStyle = `1px solid ${GREAT_WHITE}`;
export const MerchCardWrapper = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__MerchCardWrapper",
  componentId: "sc-1pwleyq-0"
})(["display:contents;", ""], breakpoint.tablet(_t || (_t = _`
    && > div {
      border-right: ${0};
    }
  `), ({
  isSuiteStarterPage
}) => !isSuiteStarterPage && `none !important`));
export const Section = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__Section",
  componentId: "sc-1pwleyq-1"
})([""]);
export const FillerRow = ({
  row,
  commonStyles
}) => /*#__PURE__*/_jsx("div", {
  style: Object.assign({
    gridRowStart: row
  }, commonStyles)
});
const commonGridStyles = css(["display:grid;background:", ";width:100%;"], OLAF);
/* stylelint-disable property-no-vendor-prefix */

export const StyledCardGrid = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__StyledCardGrid",
  componentId: "sc-1pwleyq-2"
})(["", " grid-template-columns:repeat( ", ",calc((100% / ", ") - ", "px));max-width:", ";column-gap:16px;box-shadow:0 1px 5px 0 #2d3e501f;", ";@media (min-width:", "px) and (max-width:", "px){min-width:600px;width:100% !important;}", ";"], commonGridStyles, ({
  columns
}) => columns, ({
  columns
}) => columns, ({
  columns
}) => 16 * (columns - 1) / columns, ({
  columns
}) => {
  return columns < 3 ? `calc(100% / 3 * ${columns})` : 'initial';
}, breakpoint.tablet(_t2 || (_t2 = _`
    max-width: initial;
    width: 80% !important;
    margin-top: 20px;
  `)), breakpointValues.tabletPortrait, breakpointValues.tablet - 1, breakpoint.tabletPortrait(_t3 || (_t3 = _`
    max-width: initial;
    width: 94% !important;
  `)));
export const SuiteStarterCardGrid = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__SuiteStarterCardGrid",
  componentId: "sc-1pwleyq-3"
})(["", " grid-template-columns:1fr 1fr;column-gap:64px;max-width:75%;@media (max-width:", "px){max-width:100%;column-gap:32px;}"], commonGridStyles, breakpointValues.sdMac - 1);